import React, { useCallback } from 'react';
import { Grid, GridSize, TextField } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import { PropertyField, ListingResource } from '../../../system/field';
import { EditGridLayout } from '../../../constants/Grid';
import PhoneNumber from './PhoneNumber';
import { generateDataTestId } from '../../../utils';

import { useListingField, useStatusFlag } from '@brightmls/nextgen.lae.flc';

interface OwnerDetailsProps {
  gridProps?: ResponsiveStyleValue<GridSize>;
}

const OwnerDetails: React.FC<OwnerDetailsProps> = React.memo(
  ({ gridProps }) => {
    // Direct field subscriptions - no debouncing needed! 🚀
    const ownerName = useListingField(
      ListingResource.Property,
      PropertyField.OWNER_NAME,
      '',
    );

    const ownerPhone = useListingField(
      ListingResource.Property,
      PropertyField.OWNER_PHONE,
      '',
    );

    // Use status flag for phone validation
    const phoneValidation = useStatusFlag('invalidPhone', false);

    // Handle phone validation
    const handlePhoneValidation = useCallback(
      (validation: any) => {
        phoneValidation.setValue(!validation.isValid);
      },
      [phoneValidation],
    );

    const mergedGridProps: ResponsiveStyleValue<GridSize> = {
      ...(EditGridLayout as object),
      ...(gridProps as object),
    };

    return (
      <Grid container spacing={2}>
        <Grid size={mergedGridProps}>
          <TextField
            data-testid={generateDataTestId(
              'Owner Name',
              undefined,
              'textField',
            )}
            fullWidth
            label="Owner Name"
            value={ownerName.value}
            onChange={(e) => ownerName.updateValue(e.target.value)}
            disabled={ownerName.isDisabled}
            error={ownerName.hasErrors}
            helperText={ownerName.presentation.errors[0]}
          />
        </Grid>
        <Grid size={mergedGridProps}>
          <PhoneNumber
            onValidation={handlePhoneValidation}
            onChange={ownerPhone.updateValue}
            phoneValue={ownerPhone.value}
            showInlineError
            textFieldProps={{
              fullWidth: true,
              label: 'Owner Phone',
              disabled: ownerPhone.isDisabled,
              error: ownerPhone.hasErrors,
              helperText: ownerPhone.presentation.errors[0],
            }}
            fieldLabel={'Owner Phone'}
          />
        </Grid>
      </Grid>
    );
  },
);

export default OwnerDetails;
